"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("element-closest");
var SearchToggle = (function () {
    function SearchToggle() {
        var _this = this;
        this.searchToggle = document.querySelectorAll('.search-toggle');
        this.searchToggleCount = this.searchToggle.length;
        this.searchForm = document.querySelectorAll('.search-form');
        this.searchFormCount = this.searchForm.length;
        this.menuToggle = document.querySelectorAll('.menu-toggle');
        this.menuToggleCount = this.menuToggle.length;
        var _loop_1 = function (i) {
            this_1.searchToggle.item(i).addEventListener('click', function (e) {
                _this.toggleAllSearchForms();
                _this.toggleAllSearchToggles();
                if (_this.searchToggle.item(i).classList.contains('hide')) {
                    _this.searchToggle.item(i).closest('header').querySelector('.search-form input').focus();
                }
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.searchToggleCount; ++i) {
            _loop_1(i);
        }
        for (var i = 0; i < this.menuToggleCount; ++i) {
            this.menuToggle.item(i).addEventListener('click', function (e) {
                _this.hideAllSearchForms();
                _this.showAllSearchToggles();
            });
        }
    }
    SearchToggle.getInstance = function () {
        if (!this.instance) {
            this.instance = new SearchToggle();
        }
        return this.instance;
    };
    SearchToggle.prototype.hideAllSearchForms = function () {
        for (var i = 0; i < this.searchFormCount; ++i) {
            this.searchForm.item(i).classList.remove('show');
        }
    };
    SearchToggle.prototype.toggleAllSearchForms = function () {
        for (var i = 0; i < this.searchFormCount; ++i) {
            var searchForm = this.searchForm.item(i);
            searchForm.classList.toggle('show');
        }
    };
    SearchToggle.prototype.toggleAllSearchToggles = function () {
        for (var i = 0; i < this.searchToggleCount; ++i) {
            this.searchToggle.item(i).classList.toggle('hide');
        }
    };
    SearchToggle.prototype.showAllSearchToggles = function () {
        for (var i = 0; i < this.searchToggleCount; ++i) {
            this.searchToggle.item(i).classList.remove('hide');
        }
    };
    return SearchToggle;
}());
exports.default = SearchToggle;
